import { SECONDS_IN_HOUR } from '~/utils/const';
import { sToHM } from '~/utils/dateUtils/sToHM';
import { sToMS } from '~/utils/dateUtils/sToMS';
import { translate } from '~/utils/translate';

const getUnits = (count, lessThanHour) => {
  const u1 = lessThanHour ? 'minuteShort' : 'hourShort';
  const u2 = lessThanHour ? 'secondShort' : 'minuteShort';

  return [translate('common.' + u1, { count }), translate('common.' + u2, { count })];
};
export const formatDuration = (seconds) => {
  const lessThanHour = seconds < SECONDS_IN_HOUR;
  const parseSeconds = lessThanHour ? sToMS : sToHM;

  const [val1, val2] = parseSeconds(seconds);

  let res = '';
  if (val1) {
    const [unit] = getUnits(val1, lessThanHour);
    res += `${val1} ${unit}`;
  }

  if (val2) {
    const [, unit] = getUnits(val2, lessThanHour);
    res += ` ${val2} ${unit}`;
  }

  return res.trim();
};
